module.exports = __webpack_public_path__ + "img/cart.6cd176e1.svg";